export const services = [
  {
    id: "lasik-laser",
    name: "Lasik Laser Vision Correction",
    category: "Refractive Surgery",
    description: "Advanced blade-free laser vision correction to permanently remove spectacle numbers and achieve crystal-clear sight without glasses.",
    icon: "Zap"
  },
  {
    id: "multifocal-lens",
    name: "Multifocal Lens Implants",
    category: "Lens Implants",
    description: "Premium intraocular lens (IOL) implants providing clear, seamless visual focus for near, intermediate, and distance vision without reading glasses.",
    icon: "Layers"
  },
  {
    id: "phaco-surgery",
    name: "Phacoemulsification Surgery",
    category: "Cataract Care",
    description: "State-of-the-art micro-incision ultrasound cataract surgery ensuring high precision, gentle lens removal, and rapid visual recovery.",
    icon: "ShieldCheck"
  },
  {
    id: "stitchless-cataract-surgery",
    name: "Stitchless Cataract Surgery (MICS)",
    category: "Cataract Care",
    description: "Painless, no-injection, and stitchless cataract surgery combined with foldable intraocular lens implantation for same-day recovery.",
    icon: "Sparkles"
  },
  {
    id: "glaucoma-treatment",
    name: "Glaucoma Treatment & Surgery",
    category: "Glaucoma",
    description: "Early detection of elevated intraocular pressure, continuous visual field analysis, medical management, and advanced glaucoma filtration surgery.",
    icon: "Activity"
  },
  {
    id: "squint-treatment",
    name: "Squint (Strabismus) Surgery & Correction",
    category: "Pediatric & Strabismus",
    description: "Comprehensive diagnostic assessment, specialized orthoptic exercises, and precision corrective eye muscle surgery for children and adults.",
    icon: "ScanFace"
  },
  {
    id: "oct-retina-screening",
    name: "OCT 3D Retinal Imaging & Diagnosis",
    category: "Diagnostic Imaging",
    description: "High-definition Optical Coherence Tomography (OCT) scanning providing cross-sectional 3D imaging of retinal layers and the optic nerve head.",
    icon: "Scan"
  },
  {
    id: "retina-disorders-surgery",
    name: "Retinal Disorders Diagnosis & Surgery",
    category: "Vitreoretinal Care",
    description: "Expert vitreoretinal diagnosis, retinal detachment repair, macular hole surgeries, and targeted retinal laser photocoagulation.",
    icon: "Eye"
  },
  {
    id: "oculoplastic-surgery",
    name: "Oculoplastic & Eyelid Surgery",
    category: "Reconstructive Surgery",
    description: "Specialized reconstructive and cosmetic surgery of the eyelids, tear drainage system, and orbit, including ptosis repair and blepharoplasty.",
    icon: "UserCheck"
  },
  {
    id: "pediatric-eye-surgery",
    name: "Pediatric Eye Care & Surgeries",
    category: "Pediatric Care",
    description: "Compassionate, specialized ophthalmic care for infants and children, treating congenital cataracts, lazy eye (amblyopia), and refractive errors.",
    icon: "Smile"
  },
  {
    id: "contact-lens-facility",
    name: "Specialty Contact Lens Clinic",
    category: "Optical Care",
    description: "Customized consultation and precise clinical fitting for soft, toric, multifocal, rigid gas permeable (RGP), and prosthetic contact lenses.",
    icon: "CircleDot"
  },
  {
    id: "lasru-dcr-surgery",
    name: "Lasru / DCR Tear Duct Surgery",
    category: "Lacrimal Surgery",
    description: "Advanced medical treatment and minimally invasive dacryocystorhinostomy (DCR) surgery to resolve chronic tearing and blocked tear ducts.",
    icon: "Droplet"
  },
  {
    id: "computerized-vision-testing",
    name: "Computerized Vision & Refraction Testing",
    category: "Diagnostic Testing",
    description: "Fast, fully automated autorefraction and digital keratometry to ensure pinpoint accuracy for spectacle and vision correction prescriptions.",
    icon: "Monitor"
  },
  {
    id: "diabetic-retinopathy",
    name: "Diabetic Retinopathy Diagnosis & Treatment",
    category: "Vitreoretinal Care",
    description: "Comprehensive diabetic eye screenings, specialized green retinal laser therapy, and advanced intravitreal anti-VEGF injections.",
    icon: "HeartPulse"
  },
  {
    id: "general-eye-care",
    name: "Comprehensive Eye Care & Treatment",
    category: "General Ophthalmology",
    description: "Expert evaluation and clinical treatment for eye infections, ocular allergies, dry eye syndrome, foreign body removal, and acute injuries.",
    icon: "CheckCircle2"
  },
  {
    id: "cornea-disorders-surgery",
    name: "Corneal Disorders & Surgery",
    category: "Cornea Care",
    description: "Specialized clinical care for corneal ulcers, keratoconus collagen cross-linking (C3R), pterygium excision, and corneal transplant procedures.",
    icon: "Shield"
  }
];
